<template>
  <div data-page='4' class="contact page">
    <section class="hero-content three-quarter-height">
      <gmap-map
        :center= 'map.center'
        :zoom= '11'
        :map-type-id= 'mapTypeId'
        :options= '{
          styles: mapStyle,
          disableDefaultUI: map.disableDefaultUI,
          draggable: map.draggable,
          center: map.center }'
        style='width:100%; height:100%;'
      >
        <gmap-marker
          :position='marker.position'
          :draggable='false'
          :clickable='true'
          :icon='marker.icon'
          :title='marker.title'
          @click='infoPopup'
        >
        </gmap-marker>
      </gmap-map>
    </section>
    <section class="page-text">
      <div class="">
        <div class="text-wrapper contact-form">
          <h3 class="headline">Let Melodie know what you have in mind</h3>
          <UiContactForm></UiContactForm>
      </div>
      </div>
    </section>
  </div>
</template>

<script>
  import UiModal from '@/components/UiModal.vue'
  import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
  import UiInputText from '@/components/UiInputText.vue'
  import UiContactForm from'@/components/UiContactForm.vue'
  import axios from 'axios'


  export default {
    name: 'ContactPage',

    components: {
      UiModal,
      UiBaseIcon,
      UiInputText,
      UiContactForm
    },

    data () {
      return {
        title:'Contact',
        headline:'Give us a shout for a free quote within 24 hours',
        bgTxt:'COPE',

        formTitle: '',
        formContent: '',
        formComponents: null,

        key:'AIzaSyCuECgyGmMDm2me1DqZyEVHhQyQb1WPRuQ',
        title: 'location',
        map: {
          disableDefaultUI: true,
          draggable: false,
          center: {
            lat: 37.3627041,
            lng: -122.0484772
          },
        },
        mapTypeId: 'roadmap',
        marker: {
          position: {
            lat: 37.3627041,
            lng: -122.0484772
          },
          label: "ColorBloq",
          icon: {
            labelOrigin: {
              x: 0,
              y:0
            },
            url: '/static/map-marker.png',
            size: {
              width: 80,
              height: 80,
            },
            shape: {
              cords: [1, 1, 1, 10, 18, 21, 18, 1],
              type: 'poly'
            }
          },
          title: 'ColorBloq'
        },
        mapStyle: [
          {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#82B1FF"
              },
              {
                "saturation": 7
              },
              {
                "lightness": 19
              },
            ]
          },
          {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 40
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#ffffff"
              },
              {
                "saturation": -100
              },
              {
                "lightness": 100
              },
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "saturation": "-100"
              },
              {
                "lightness": 31
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
              {
                "hue": "#bbc0c4"
              },
              {
                "saturation": -93
              },
              {
                "lightness": 31
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              },
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 17
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 29
              },
              {
                "weight": .2
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
              {
                "lightness": "16"
              },
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
              {
                "hue": "#e9ebed"
              },
              {
                "saturation": -90
              },
              {
                "lightness": -8
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
              {
                "hue": "#bbc0c4"
              },
              {
                "saturation": -93
              },
              {
                "lightness": -2
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#eef5fd"
              },
              {
                "saturation": -58
              },
              {
                "lightness": 30
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
              {
                "lightness": -25
              },
              {
                "saturation": -100
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#adcef6"
              }
            ]
          },
        ],
      }
    },

    methods: {

    }

  }
</script>

<style lang="scss" scoped>
  .contact-text {
    font-size: 15rem;
    font-family: $title;
    color: rgba($prime-color, .5);
    position: absolute;
  }

  .contact {
    .contact-form {
      background-color: $prime-color;
      margin: 0 auto;
      transform: translateY(-100px);
      box-shadow: 0 2.5em 2.5em -1.875em rgba(0, 0, 0, .5),
      0 1.25em 5em 1em rgba(0, 0, 0, .2);
      border-radius: 6px;
    }

    .page-text {
      z-index: 2;
      position: relative;
    }

    .headline {
      color: $white;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue